import theme from 'theme';

const pageContainerSx = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1
};

export const backgroundColorContainerSx = {
  background: theme.palette.background.default,
  flex: 1,
  display: 'flex',
  flexDirection: 'column'
};

const contentContainerSx = {
  paddingTop: theme.padding.container,
  paddingBottom: theme.padding.container,
  minHeight: '100%'
};

export const sectionGridSx = {
  paddingTop: theme.padding.section
};

export const tagGridSx = {
  marginTop: theme.padding.content,
  marginBottom: theme.padding.content
};

export const centeredBoxSx = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

export const dividerContainerSx = {
  padding: theme.padding.section
};

export const emptyStateContainerSx = ({
  compact = false
} = {}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: compact ? '8px' : '16px',
  paddingTop: compact ? '16px' : '32px',
  paddingBottom: compact ? '16px' : '32px'
});

export const mainDivSx = {
  display: 'flex',
  flex: 1,
  flexDirection: 'column'
};

export const pageContentContainerSx = [contentContainerSx, {
  px: {
    xs: 0,
    sm: 2
  }
}];

export const mainPageContainerSx = [pageContainerSx, {
  px: {
    xs: 1,
    sm: 2
  }
}];
